import React from 'react';
import { Box, Typography } from '@material-ui/core';

const Watermark = ({ text }) => {
    return (
        <Box className="watermark-text">
            <Typography variant="h2">
                {text}
            </Typography>
        </Box>
    );
};

export default Watermark;